import React from 'react';
import { message, Tooltip } from 'antd';
import Documents from '../../../Documents/Documents';
import UploadButton from '../../../../../../../components/UploadButton/UploadButton';
import { maxFileSize } from '../../../../../../../constants/maxFileSize';
import { attachmentColumnAmounts } from '../../../../../../../components/NewAttachment';
import styles from './AttachmentsContainer.module.scss';
import { useSelector } from 'react-redux';

const beforeUpload = (file) => {
  if (file.size > maxFileSize) {
    message.error(`Файл ${file.name} весит больше 15 мб`);
    return false;
  }

  return true;
};

const AttachmentsContainer = ({
  items,
  title,
  loading,
  addBtnDisabled,
  onAddAttachments,
  onDeleteAttachment,
  getAttachmentUrl,
  meter,
}) => {
  const booleanDisable = useSelector((state) => state.housingStockStore.meterModalData?.isInfo);

  return (
    <Documents
      className={meter?.statusId === 5 && booleanDisable ? `${styles.root} ${styles.disable}` : styles.root}
      headerClassName={styles.cardHeader}
      attachmentClassName={styles.attachment}
      titleClassName={styles.cardTitle}
      docs={items}
      title={title}
      loading={loading}
      darkTheme={false}
      showActions={false}
      showAdditionalContent={false}
      renderAddBtn={() => (
        <UploadButton
          multiple
          showUploadList={false}
          disabled={addBtnDisabled}
          beforeUpload={beforeUpload}
          customRequest={onAddAttachments}
          className={styles.upload}
          buttonText="Перетащите файл или нажмите, чтобы выбрать"
        />
      )}
      getAttachmentUrl={getAttachmentUrl}
      onDeleteDocument={onDeleteAttachment}
      columnAmount={attachmentColumnAmounts.four}
    />
  );
};

export default AttachmentsContainer;
